<template>
  <article>
    <main class="body" role="main" id="main">
      <header-image :fields="fields"/>
      <div class="content-container">
        <white-board-with-button :fields="fields"/>
        <double-text :fields="fields"/>
        <image-block :isPerksPage="true" :fields="fields"/>
        <terms-and-conditions :fields="fields"/>
      </div>
    </main>
  </article>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue'
import HeaderImage from '../../header-image-editorial'
import ImageBlock from '../../image-block'
import DoubleText from '../../double-text'
import WhiteBoardWithButton from '../../white-board-with-button'
import TermsAndConditions from '../../terms-and-conditions'

export default {
  name: 'PerkDetails',
  head () {
    return {
      title: this.$t('META_TITLE_PERKS'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('META_DESCRIPTION_PERKS') }
      ]
    }
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRichText: RichText,
    HeaderImage,
    WhiteBoardWithButton,
    ImageBlock,
    DoubleText,
    TermsAndConditions
  }
}
</script>

<style lang="scss" scoped>

.content-container {
  max-width: 44em;
  margin: 0 $space-060;
  @include tablet {
    width: 80%;
    margin: 0 auto;
  }
}

</style>
